export const headCells = [
    {
        id: "Category Name",
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: "Category Name",
        width: 180
    },
    {
        id: "Name",
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: "Name",
        width: 180
    },
    {
        id: "Image",
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: "Image",
        width: 150
    },
    {
        id: "SortOrder",
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: "Sort Order",
        width: 100
    },
    {
        id: "Status",
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: "Status",
        width: 130
    },
    {
        id: "Actions",
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: "Actions",
        width: 120
    }
];

export const rowsPerPageOptions = [10, 25, 50, 100];
